import { render, staticRenderFns } from "./reporta1.vue?vue&type=template&id=69215d1c&"
import script from "./reporta1.vue?vue&type=script&lang=js&"
export * from "./reporta1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports